export default {
  getInsertOptions() {
    return [
      {
        label: 'Brand',
        value: 'brand',
        example: 'Allcamps',
      },
      {
        label: 'Domain',
        value: 'domain',
        example: 'allcamps.de',
      },
      {
        label: 'Booking Ref',
        value: 'bookingRef',
        example: 'LU1000000',
      },
      {
        label: 'Voucher Ref',
        value: 'voucherRef',
        example: 'ABCDE-12345',
      },
      {
        label: 'Currency',
        value: 'currency',
        example: '€',
      },
      {
        label: 'Amount',
        value: 'amount',
        example: '1.123,29',
      },
      {
        label: 'Expiration Date',
        value: 'expirationDate',
        example: '01-01-2020',
      },
      {
        label: 'Issue Date',
        value: 'issueDate',
        example: '01-01-2019',
      },
      {
        label: 'Customer',
        value: 'customer',
        example: 'Test Customer',
      },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucherTemplates/getters.js